<!--
 * @Autor: yingna.gao
 * @Date: 2022-02-24 15:13:20
 * @LastEditTime: 2022-08-01 14:21:54
 * @LastEditors: yingna.gao
 * @Description:
 * @FilePath: /common-web/src/components/private/edm-select/index.vue
-->
<template>
  <el-select
    v-bind="$attrs"
    ref="edmSelectEl"
    v-loadmore="() => { $attrs.remote ? selectLoadMore() : '' }"
    :remote-method="($event) => { $attrs.remote ? selectRemoteMethod($event) : '' }"
    v-on="$listeners"
    @visible-change="($event) => { $attrs.remote ? selectFocus($event) : '' }"
  >
    <slot></slot>
  </el-select>
</template>

<script>
export default {
  name: "EdmSelect",
  props: {
    selectData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      searchValue: ""
    };
  },
  watch: {
    selectData: {
      handler(newList, oldList) {
        if (newList.length === 0 && this.$refs.edmSelectEl) {
          this.$refs.edmSelectEl.query = null;
        }
      },
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
    selectLoadMore() {
      const { pageNum, pageSize } = this.$attrs.pagination;
      // this.pagination.total = Number(this.selectData.length);
      const totalPage = Math.ceil(this.$attrs.pagination.total / this.$attrs.pagination.pageSize);
      const dataFilter = this.selectData.filter(o => !o.hidden);
      if ((dataFilter.length === pageNum * pageSize) && pageNum < totalPage) {
        const pageNumAdd = this.$attrs.pagination.pageNum + 1;
        const pagination = Object.assign(this.$attrs.pagination, { pageNum: pageNumAdd });
        this.$emit("loadMore", {
          pagination,
          searchValue: this.searchValue,
          restData: false
        });
      }
    },
    selectRemoteMethod(query) {
      if (query !== "") {
        this.searchValue = query;
      } else {
        this.searchValue = "";
      }
      this.pagination.pageNum = 1;
      this.$emit("loadMore", {
        pagination: this.pagination,
        searchValue: this.searchValue,
        restData: true
      });
    },
    selectFocus(val) {
      if (val) {
        this.pagination.pageNum = 1;
        this.searchValue = "";
        this.$emit("loadMore", {
          pagination: this.pagination,
          searchValue: this.searchValue,
          restData: true
        });
      }
    }
  }
};
</script>

<style>

</style>
